module.exports = __webpack_public_path__ + "img/built-loopers.b624de6a.svg";